interface EmptyStateProps {
  title: string;
  description: string;
  phase?: number | null;
}

export default function EmptyState({ title, description, phase }: EmptyStateProps) {
  const phaseLabel =
    phase === null || phase === undefined
      ? 'Unscheduled'
      : `Coming in Phase ${phase}`;

  return (
    <div className="flex flex-col items-center justify-center min-h-[40vh] md:min-h-[60vh] text-center px-4">
      <h1 className="font-heading text-2xl md:text-4xl font-bold text-gray-100 mb-3 md:mb-4">
        {title}
      </h1>
      <p className="font-body text-base md:text-lg text-gray-300 mb-6 md:mb-8 max-w-md">
        {description}
      </p>
      <span className="inline-block rounded-full border border-accent-teal/40 bg-accent-teal/10 px-4 md:px-5 py-2 font-mono text-sm text-accent-teal">
        {phaseLabel}
      </span>
    </div>
  );
}
